export * from "./util/public";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/misc/public.js
// module id = 1087
// module chunks = 0